/**
 * Разговор с бухгалтером-калькулятором — `accountant-api` (D236).
 *
 * Адреса свои, а не `ops-api`: бухгалтер импортирует два сервиса сразу и
 * живёт своим процессом (`accountant/api/main.py`).
 */

import { request } from '../../api';

export interface Turn {
  role: 'user' | 'assistant';
  text: string;
  /** Инструменты, которыми собран ответ, — для строки «что я сделал». */
  steps: string[];
  verdict: string | null;
  at: string | null;
}

export interface Answer {
  text: string;
  did: string;
  verdict: 'ok' | 'rewritten' | 'fallback' | 'offline' | 'refused';
  note: string | null;
}

export const accountantApi = {
  dialog: () => request<{ turns: Turn[] }>('/api/accountant/dialog'),
  fresh: () => request<{ turns: Turn[] }>('/api/accountant/new', { method: 'POST' }),
  ask: (question: string) =>
    request<Answer>('/api/accountant/ask', { method: 'POST', body: { question } }),
};
